<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_orderNo']"
      :button-items="['add_btn']"
      :columns="columns"
      :queryParams="queryParams"
      rowKey="enterpriseId"
      :leftSpace="20"
      requestType="post"
      :requestPromise="loadDataList"
    >
      <a-form-item slot="search_orderNo" label="企业全称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.enterpriseFullName" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-button slot="add_btn" type="primary" icon="plus" @click="onAddEvent" style="margin-left: 12px">新建
      </a-button>
      <template slot="status" slot-scope="rowItem">
        {{ rowItem.record.status == 1 ? '启用' : '禁用' }}
      </template>
      <span slot="action" slot-scope="rowItem">
        <!--编辑 员工 认证设置 审批设置 组织架构 禁用-->
        <a-space>
           <a @click="onEditEvent(rowItem.record)">编辑</a>
           <a @click="toEmployeeList(rowItem.record)">员工</a>
           <a @click="toFirstRechargeList(rowItem.record)">首次充值</a>
           <a @click="toAuthenticationSettings(rowItem.record)">认证设置</a>
           <a @click="toApprovalWorkflow(rowItem.record)">审批设置</a>
           <a @click="toOrganizationalStructure(rowItem.record)">组织架构</a>
           <a @click="onSwitchStatus(rowItem.record)">{{ rowItem.record.status == 1 ? '禁用' : '启用' }}</a>
        </a-space>
      </span>
    </search-page-view>
    <SimpleFormEditorDialog
      v-if="showDialog"
      @cancel="showDialog=false"
      :title="selectItem?'编辑企业':'新增企业'"
      :rules="rules"
      :editConfigList="editConfigList"
      :item="selectItem"
      @ok="onSubmitEvent"
    ></SimpleFormEditorDialog>
  </a-card>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import ValidatorHelper from '@/utils/helper/validatorHelper'

export default {
  name: 'VerificationList',
  mixins: [searchForm],
  components: {
    SimpleFormEditorDialog: SimpleFormEditorDialog
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      showDialog: false,
      columns: [
        {
          title: '企业ID',
          dataIndex: 'enterpriseId',
          width: '90px'
        },
        {
          title: '公司全称',
          dataIndex: 'enterpriseFullName',
          width: '320px'
        },
        {
          title: '认证方式',
          dataIndex: 'authMethodStr',
          width: '260px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '400px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      rules: {
        enterpriseFullName: [
          { required: true, message: '请输入企业全称', trigger: 'change' }
        ],
        rechargeAmount: [
          { required: true, message: '请输入首次充值额度', trigger: 'change' }
        ],
        adminEmail: ValidatorHelper.createEmailRule('请输入管理员邮箱', '管理员邮箱格式有误'),
        adminPhone: ValidatorHelper.createMobileRule(true, '请输入管理员手机号', '手机号码格式有误')
      },
      editConfigList: [
        {
          name: '企业全称',
          key: 'enterpriseFullName',
          placeholder: '请输入企业全称'
        },
        {
          name: '管理员邮箱',
          key: 'adminEmail',
          placeholder: '请输入管理员邮箱'
        },
        {
          name: '管理员手机号',
          key: 'adminPhone',
          placeholder: '请输入管理员手机号'
        },
        {
          name: '固定首充金额',
          key: 'rechargeAmount',
          placeholder: '请输入固定首充金额'
        },
        {
          name: '自动充值',
          radioOptions: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是'
            }
          ],
          key: 'rechargeStatus'// 1是自动充值
        },
        {
          name: '额外抵扣范围',
          radioOptions: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '允许抵扣儿童价'
            },
            {
              value: 2,
              label: '允许抵扣房差'
            },
            {
              value: 3,
              label: '允许抵扣儿童价跟房差'
            }
          ],
          key: 'allowEmployeePay'// 1是自动充值
        },
        {
          name: '开启员工白名单认证',
          radioOptions: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是'
            }
          ],
          key: 'allowWhiteEmployee'// 1是开启员工白名单认证，0是关闭
        }
      ],
      queryParams: {},
      selectItem: undefined
    }
  },
  activated() {
    this.$refs.pageList?.refresh(false)
  },
  methods: {
    loadDataList(params) {
      return this.getHttpServices().getMemberAuthService().post('member/v3/auth/getEnterpriseList', params)
    },
    onEditEvent(item) {
      const url = `member/v3/auth/getEnterpriseDetail/${item.enterpriseId}`
      this.getHttpServices().getMemberAuthService().post(url)
        .then(data => {
          const { rechargeAmount, rechargeStatus } = data
          this.selectItem = {
            ...data,
            rechargeStatus: rechargeStatus ? 1 : 0,
            rechargeAmount: rechargeAmount
          }
          this.showDialog = true
        })
        .catch(err => {
          console.error(err)
          this.$message.error('操作失败，请重试！')
        })
    },
    getPageParams(item) {
      return { enterpriseId: item.enterpriseId, enterpriseFullName: item.enterpriseFullName }
    },
    toEmployeeList(item) {
      this.openNewPage('EmployeeList', this.getPageParams(item))
    },
    toFirstRechargeList(item) {
      this.openNewPage('FirstRechargeList', this.getPageParams(item))
    },
    toAuthenticationSettings(item) {
      this.openNewPage('AuthenticationSettings', this.getPageParams(item))
    },
    toOrganizationalStructure(item) {
      this.openNewPage('OrganizationalStructure', this.getPageParams(item))
    },
    toApprovalWorkflow(item) {
      this.openNewPage('ApprovalWorkflow', this.getPageParams(item))
    },
    onSwitchStatus(item) {
      const params = {
        enterpriseId: item.enterpriseId,
        status: String(item.status) === '1' ? 2 : 1
      }
      this.getHttpServices().getMemberAuthService().post('member/v3/auth/updateEnterpriseStatus', params)
        .then(res => {
          this.$refs.pageList.refresh(false)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
    },
    onChange() {
    },
    onAddEvent() {
      this.selectItem = {
        rechargeStatus: 0,
        allowWhiteEmployee: 0,
        allowEmployeePay: 0
      }
      this.showDialog = true
    },
    onSubmitEvent(params) {
      this.showDialog = false
      this.getHttpServices().getMemberAuthService().post('member/v3/auth/saveAuthEnterprise', params)
        .then(res => {
          this.$refs.pageList.refresh(!!params.enterpriseId)
          const msg = params.enterpriseId ? '编辑成功！' : '新增成功！'
          this.$message.success(msg)
          console.error(res)
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
      console.error('onSubmitEvent', params)
    }
  }
}
</script>
<style scoped lang="less">

</style>